import { render, staticRenderFns } from "./HomeGovernmentComponent.vue?vue&type=template&id=e8e056e2"
import script from "./HomeGovernmentComponent.vue?vue&type=script&lang=js"
export * from "./HomeGovernmentComponent.vue?vue&type=script&lang=js"
import style0 from "./HomeGovernmentComponent.vue?vue&type=style&index=0&id=e8e056e2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports